import { handleClick } from "../Analitics/GoogleAnalytics4";
import { SubscribeBtn } from "./style";
import { TooltipInfo } from "../TooltipInfo";

export const SubscribeButton = ({
  suscriptionPrice,
  type,
  title,
  titleGA4 = "header clarin",
}) => {
  let price =
    suscriptionPrice && suscriptionPrice !== "" && "por $" + suscriptionPrice;

  return (
    <SubscribeBtn
      type={type}
      href="/suscripciones/suscribite.html"
      onClick={() => handleClick("ui_interaction", titleGA4, "Suscribirme")}
    >
      {title}&nbsp;<span className="price">{price}</span>
      {/* <span className="priceBefore">por <strong>$830</strong></span><span className="price">$420</span> */}
      {/*
        {titleGA4 === "header clarin" ? (
        <TooltipInfo
          title={
            <>
              <span className="title-bold">¡CYBERMONDAY EN CLARÍN!</span>
            </>
          }
          // alt="logo-HOTSALE"
          // img="https://www.clarin.com/images/collections/Hot%20Sale/hot-sale-fire___6824fc42045a4c001b017d5c.png"
          position="bottom"
          customClass="toolTip_text_center"
          onProcessGA={true}
          tooltipGASection="ToolTip_promoFlash_buttonSuscribe"
          tooltipGAName="close_promoFlash_tooltip"
        >
        </TooltipInfo>
      ) : null}
    */}
    </SubscribeBtn>
  );
};
